import { render, staticRenderFns } from "./distribution-list-layout.vue?vue&type=template&id=142af278&"
import script from "./distribution-list-layout.vue?vue&type=script&lang=js&"
export * from "./distribution-list-layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* nuxt-component-imports */
installComponents(component, {ReportStatusWatcher: require('/lasso/components/reports/ReportStatusWatcher.vue').default,RfiImportStatusWatcher: require('/lasso/components/templates/RfiImportStatusWatcher.vue').default,QuickStartModal: require('/lasso/components/support/QuickStartModal.vue').default,NavMobile: require('/lasso/components/NavMobile.vue').default,Header: require('/lasso/components/Header.vue').default,Error: require('/lasso/components/Error.vue').default,PageHeader: require('/lasso/components/PageHeader.vue').default,DistributionListsHeader: require('/lasso/components/distribution-lists/DistributionListsHeader.vue').default,Breadcrumb: require('/lasso/components/Breadcrumb.vue').default,Footer: require('/lasso/components/Footer.vue').default,AssistantBubble: require('/lasso/components/AssistantBubble.vue').default})


/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('142af278')) {
      api.createRecord('142af278', component.options)
    } else {
      api.reload('142af278', component.options)
    }
    module.hot.accept("./distribution-list-layout.vue?vue&type=template&id=142af278&", function () {
      api.rerender('142af278', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "layouts/distribution-list-layout.vue"
export default component.exports